var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "rtb-stats__widget" },
    [
      _vm.hasRtb
        ? [
            _c("SmartTableWidget", {
              attrs: {
                widget: {
                  tableTitle: _vm.$t("RTB_BREAKDOWN_PANE_TITLE"),
                  iconClass: "fa fa-trophy",
                  locale: _vm.$options.i18n
                },
                "date-range": _vm.publisherRange,
                "column-defs": _vm.columnSettings.tableData,
                "row-data": _vm.tableData || [],
                "enable-export": true,
                "export-title": _vm.formatTitleWithCampaignName(
                  "RTB Stats by Publisher"
                ),
                icon: "fa-chevron-down"
              },
              on: { "update-date-range": _vm.updateStats },
              scopedSlots: _vm._u(
                [
                  {
                    key: "table",
                    fn: function() {
                      return [
                        _vm.loadingBreakdown
                          ? _c("LoadingStatusDisplay", {
                              attrs: { loading: true }
                            })
                          : !_vm.tableData.length
                          ? _c("div", { staticClass: "empty-records" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("RTB_BREAKDOWN_PANE_EMPTY")) +
                                  "\n        "
                              )
                            ])
                          : _vm._e()
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                3348521134
              )
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }